import { Dispatch } from 'redux'
import { api } from '../../Controllers/api'
import { Contact, ContactInput } from '../Types/types'

export const REQUEST_CONTACTS = 'REQUEST_CONTACTS'
export const RECEIVE_CONTACTS = 'RECEIVE_CONTACTS'
export const EDIT_CONTACT = 'EDIT_CONTACT'
export const CREATE_CONTACT = 'CREATE_CONTACT'

export interface RequestContactsAction {
  type: typeof REQUEST_CONTACTS
  loading: boolean
}

export interface GetContactsAction {
  type: typeof RECEIVE_CONTACTS
  payload: { data: Contact[] }
  loading: boolean
}

export interface UpdateContactAction {
  type: typeof EDIT_CONTACT
  payload: { data: Contact }
  loading: boolean
}

export interface AddContactAction {
  type: typeof CREATE_CONTACT
  payload: { data: Contact }
  loading: boolean
}

const requestContacts = (): RequestContactsAction => {
  return {
    type: REQUEST_CONTACTS,
    loading: true
  }
}

const receiveContacts = (data: Contact[]): GetContactsAction => {
  return {
    type: RECEIVE_CONTACTS,
    payload: { data },
    loading: false
  }
}

const editedContact = (data: Contact): UpdateContactAction => {
  return {
    type: EDIT_CONTACT,
    payload: { data },
    loading: false
  }
}

const createdContact = (data: Contact): AddContactAction => {
  return {
    type: CREATE_CONTACT,
    payload: { data },
    loading: false
  }
}

const getContacts = (isRefresh: boolean) => {
  return (dispatch: Dispatch<GetContactsAction | RequestContactsAction>) => {
    if (!isRefresh) {
      dispatch(requestContacts())
    }
    api.get(`contacts`).then(({ data }) => {
      dispatch(receiveContacts(data))
    })
  }
}

const editContact = (contact: ContactInput, _id: string) => {
  const payload = { ...contact }
  return (dispatch: Dispatch<UpdateContactAction>) => {
    api.put(`contacts/${_id}`, payload).then(({ data }) => {
      dispatch(editedContact({ ...contact, _id }))
    })
  }
}

const createContact = (contact: Contact) => {
  return (dispatch: Dispatch<AddContactAction>) => {
    api.post(`contacts`, contact).then(({ data }) => {
      dispatch(createdContact({ ...contact, _id: data._id }))
    })
  }
}

export { getContacts, editContact, createContact }
